<button class="close" mat-button (click)="onNoClick()">X</button>

<ng-container>
  <div class="container aviso">
    <div class="tituloSearch row">{{ 'MESSAGE_PAUSAR_VENTA' | translate }}</div>
    <div class="row font-weight-bold text-centro">
      {{ 'DESCRIPCION_PAUSAR_VENTA' | translate }}
    </div>
    <ng-container *ngIf="showForm">
      <form [formGroup]="tagForm" class="form-dialog">
        <mat-form-field class="custom-form-field">
          <mat-label>{{ 'TAG' | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'TAG' | translate }}"
            formControlName="tag"
          />
          <mat-error *ngIf="validateFields('tag')">
            {{ getErrorMessage("tag") }}
          </mat-error>
        </mat-form-field>
      </form>
    </ng-container>
    
    <div class="container avisoInputWrap mt-3">
      <div class="faturacion-fila row">
        <div class="ticket-info col-6">
          <div class="inputControl botones">
            <button
              type="button"
              value="cancelar"
              class="cancelar"
              (click)="onNoClick()"
            >
              {{ 'CANCELAR' | translate }}
            </button>
          </div>
        </div>
        <div class="ticket-info col-6">
          <div class="inputControl botones">
            <button type="button" (click)="confirm()" class="pagar aceptar">
              {{ 'ACEPTAR' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
